/* Calmo: warstwa ruchu. Odslanianie sekcji, liczby doliczajace sie w gore,
   pasek postepu czytania, parallaks tla hero, pasek zakupu na mobile.

   Zasada bezpieczenstwa: tresc nigdy nie moze zostac niewidoczna. Odslanianie
   opiera sie na zwyklym scrollu (nie na IntersectionObserver, ktory potrafi
   nie odpalic w nieaktywnej karcie), a dodatkowy licznik odslania wszystko
   po szesciu sekundach, gdyby cokolwiek zawiodlo. */
(function () {
  var root = document.documentElement;

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  root.classList.add('calmo-motion');

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn, { once: true });
  }

  ready(function () {
    var main = document.getElementById('MainContent');
    if (!main) return;

    /* --- 1. Sekcje wchodza z dolu, po kolei --- */
    var pending = [];

    Array.prototype.forEach.call(main.querySelectorAll('.shopify-section'), function (section, index) {
      if (index === 0) return;
      section.classList.add('calmo-reveal');
      pending.push(section);

      var items = section.querySelectorAll(
        '.multicolumn-list__item, .metoda__card, .grid__item, .calmo-router__row, ' +
          '.calmo-router__stat, .calmo-zestaw, .calmo-opinia'
      );
      /* Uwaga: .calmo-prot__cell i .calmo-dow__cell maja wlasny mechanizm
         odslaniania (.calmo-odslon) z regulami !important, wiec ich tu nie
         ruszamy, zeby dwa mechanizmy nie walczyly o te sama przezroczystosc. */
      var step = window.innerWidth < 750 ? 45 : 65;
      Array.prototype.forEach.call(items, function (item, i) {
        item.classList.add('calmo-reveal-item');
        item.style.setProperty('--calmo-delay', (i % 8) * step + 'ms');
      });
    });

    var ticking = false;

    /* Po odslonieciu kasujemy --calmo-delay, zeby pozniejszy hover na
       kafelku czy pakiecie nie czekal na opoznienie z wejscia. */
    function markIn(el) {
      el.classList.add('calmo-in');
      window.setTimeout(function () {
        var kids = el.querySelectorAll('.calmo-reveal-item');
        Array.prototype.forEach.call(kids, function (kid) {
          kid.style.removeProperty('--calmo-delay');
        });
      }, 1400);
    }

    function revealAll() {
      pending.forEach(markIn);
      pending = [];
      teardown();
    }

    /* Na telefonie odslaniamy wczesniej niz na desktopie: przy szybkim
       przewijaniu prog 0.92 wysokosci ekranu pokazywal na moment pusto. */
    function revealLimit() {
      return window.innerHeight * (window.innerWidth < 750 ? 1.05 : 0.92);
    }

    function check() {
      ticking = false;
      var limit = revealLimit();
      for (var i = pending.length - 1; i >= 0; i--) {
        if (pending[i].getBoundingClientRect().top < limit) {
          markIn(pending[i]);
          pending.splice(i, 1);
        }
      }
      if (!pending.length) teardown();
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(check);
    }

    function teardown() {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      document.removeEventListener('visibilitychange', onScroll);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    document.addEventListener('visibilitychange', onScroll);
    check();

    /* Siatka bezpieczenstwa: po szesciu sekundach nic nie zostaje ukryte. */
    window.setTimeout(revealAll, 6000);

    /* --- 2. Liczby doliczaja sie w gore, raz --- */
    var numbers = Array.prototype.slice.call(main.querySelectorAll('[data-calmo-count]'));

    function checkNumbers() {
      var limit = window.innerHeight * 0.85;
      for (var i = numbers.length - 1; i >= 0; i--) {
        var rect = numbers[i].getBoundingClientRect();
        if (rect.top < limit && rect.bottom > 0) {
          countUp(numbers[i]);
          numbers.splice(i, 1);
        }
      }
      if (!numbers.length) window.removeEventListener('scroll', onNumberScroll);
    }

    var numberTicking = false;
    function onNumberScroll() {
      if (numberTicking) return;
      numberTicking = true;
      window.requestAnimationFrame(function () {
        numberTicking = false;
        checkNumbers();
      });
    }

    if (numbers.length) {
      window.addEventListener('scroll', onNumberScroll, { passive: true });
      checkNumbers();
    }

    function countUp(el) {
      var target = parseFloat(el.getAttribute('data-calmo-count'));
      if (isNaN(target)) return;
      var suffix = el.getAttribute('data-calmo-suffix') || '';
      var duration = 1000;
      var start = null;

      function frame(now) {
        if (start === null) start = now;
        var progress = Math.min((now - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.round(target * eased) + suffix;
        if (progress < 1) window.requestAnimationFrame(frame);
        else el.textContent = target + suffix;
      }

      el.textContent = '0' + suffix;
      window.requestAnimationFrame(frame);
    }

    /* --- 3. Pasek postepu czytania: cienka linia w kolorze marki --- */
    var progress = document.createElement('div');
    progress.className = 'calmo-progress';
    progress.setAttribute('aria-hidden', 'true');

    var progressBar = document.createElement('span');
    progressBar.className = 'calmo-progress__bar';
    progress.appendChild(progressBar);
    document.body.appendChild(progress);

    var progressTicking = false;

    function paintProgress() {
      progressTicking = false;
      var doc = document.documentElement;
      var span = doc.scrollHeight - window.innerHeight;
      var ratio = span > 0 ? (window.pageYOffset || doc.scrollTop) / span : 0;
      if (ratio < 0) ratio = 0;
      if (ratio > 1) ratio = 1;
      progressBar.style.transform = 'scaleX(' + ratio.toFixed(4) + ')';
    }

    function onProgressScroll() {
      if (progressTicking) return;
      progressTicking = true;
      window.requestAnimationFrame(paintProgress);
    }

    window.addEventListener('scroll', onProgressScroll, { passive: true });
    window.addEventListener('resize', onProgressScroll);
    paintProgress();

    /* --- 4. Parallaks tla hero. Bardzo malo, tylko zeby warstwy sie
       rozjechaly przy scrollu. Przesuwamy .calmo-hero__media, bo samo
       zdjecie ma juz wlasna animacje zblizenia i nie wolno jej nadpisac.
       CSS daje warstwie 8% zapasu u gory i u dolu. --- */
    var heroSection = document.querySelector('.calmo-hero');
    var heroMedia = heroSection && heroSection.querySelector('.calmo-hero__media');

    if (heroMedia) {
      var heroTicking = false;

      function paintHero() {
        heroTicking = false;
        var rect = heroSection.getBoundingClientRect();
        if (rect.bottom <= 0) return;
        var cap = rect.height * 0.07;
        var shift = Math.max(-rect.top, 0) * 0.16;
        if (shift > cap) shift = cap;
        heroMedia.style.transform = 'translate3d(0, ' + shift.toFixed(1) + 'px, 0)';
      }

      function onHeroScroll() {
        if (heroTicking) return;
        heroTicking = true;
        window.requestAnimationFrame(paintHero);
      }

      window.addEventListener('scroll', onHeroScroll, { passive: true });
      window.addEventListener('resize', onHeroScroll);
      paintHero();
    }

    /* --- 5. Pasek zakupu na mobile, gdy glowny przycisk zjedzie z ekranu --- */
    var submit = main.querySelector('.product-form__submit');
    if (!submit) return;

    var titleEl = main.querySelector('.product__title h1') || main.querySelector('.product__title');
    var priceEl =
      main.querySelector('.price__container .price-item--sale') ||
      main.querySelector('.price__container .price-item--regular');

    var bar = document.createElement('div');
    bar.className = 'calmo-buybar';
    bar.setAttribute('aria-hidden', 'true');

    var info = document.createElement('div');
    info.className = 'calmo-buybar__info';

    var title = document.createElement('span');
    title.className = 'calmo-buybar__title';
    title.textContent = titleEl ? titleEl.textContent.trim() : '';

    var price = document.createElement('span');
    price.className = 'calmo-buybar__price';
    price.textContent = priceEl ? priceEl.textContent.trim() : '';

    info.appendChild(title);
    info.appendChild(price);

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'button calmo-buybar__btn';
    button.textContent = 'Do koszyka';
    button.addEventListener('click', function () { submit.click(); });

    bar.appendChild(info);
    bar.appendChild(button);
    document.body.appendChild(bar);

    /* Dwa przyklejone paski przy dolnej krawedzi to jeden za duzo.
       CSS chowa .calmo-sticky, gdy na stronie jest .calmo-buybar. */
    root.classList.add('calmo-has-buybar');

    var barTicking = false;
    function onBarScroll() {
      if (barTicking) return;
      barTicking = true;
      window.requestAnimationFrame(function () {
        barTicking = false;
        var gone = submit.getBoundingClientRect().bottom < 0;
        bar.classList.toggle('calmo-buybar--on', gone);
        bar.setAttribute('aria-hidden', gone ? 'false' : 'true');
      });
    }

    window.addEventListener('scroll', onBarScroll, { passive: true });
    onBarScroll();
  });
})();
